import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await fetch(`${API}/blogs`);
      if (res.ok) {
        setBlogs(await res.json());
      }
    } catch (e) {
      console.error("Error fetching blogs:", e);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const latestBlog = blogs[0];
  const otherBlogs = blogs.slice(1);

  return (
    <div className="page-wrapper" data-testid="blog-page">
      <div className="myspace-container">
        {/* Header */}
        <div className="myspace-header">
          <h3>kezzio's blog</h3>
        </div>

        {loading ? (
          <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-8">
            Loading blogs...
          </div>
        ) : blogs.length > 0 ? (
          <table className="profile-table">
            <tbody>
              <tr>
                {/* Main Blog Content */}
                <td className="right-column" style={{ width: '70%' }}>
                  <div className="myspace-section m-2" data-testid="latest-blog-full">
                    <div className="myspace-section-title">:: Latest Entry ::</div>
                    <div className="myspace-section-content">
                      <div className="blog-entry-2006">
                        <div className="blog-title">{latestBlog.title}</div>
                        <div className="blog-date">{formatDate(latestBlog.created_at)}</div>
                        <div className="blog-content whitespace-pre-wrap">
                          {latestBlog.content}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                {/* Sidebar */}
                <td className="left-column" style={{ width: '30%' }}>
                  <div className="myspace-section m-2" data-testid="other-blogs-section">
                    <div className="myspace-section-title">Other Entries</div>
                    <div className="myspace-section-content">
                      {otherBlogs.length > 0 ? (
                        <ul className="link-list">
                          {otherBlogs.map((blog, index) => (
                            <li key={blog.id}>
                              <Link 
                                to={`/blog/${blog.id}`}
                                data-testid={`other-blog-${index}`}
                              >
                                {blog.title}
                              </Link>
                              <div className="text-[10px] text-[var(--text-white)] opacity-70">
                                {formatDate(blog.created_at)}
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="text-[var(--text-white)] opacity-80 text-[11px]">No other entries</div>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-8">
            No blog entries yet. Check back soon!
          </div>
        )}

        {/* Footer */}
        <div className="text-center text-[10px] text-[var(--text-white)] opacity-50 py-3 border-t border-[var(--border-color)]">
          <a href="/" className="text-[var(--text-link)]">&laquo; Back to Home</a>
        </div>
      </div>
    </div>
  );
}
